<template>
  <div id="contratos-toolbar-contratos">
    <v-toolbar flat>
      <v-btn v-if="mostrarBtnRegresar | $vuetify.breakpoint.mobile" icon @click="botonRegresar">
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <v-toolbar-title class="display-1">
        {{ titulo }}
      </v-toolbar-title>
      <contratos-selector
        v-if="datos && datos.ejercicio"
        :ejercicio="datos.ejercicio"
        :id-contrato-actual="datos.id">
      </contratos-selector>
      <v-spacer></v-spacer>
      <custom-button
        v-if="mostrarBotonPlantillas"
        label="Plantillas"
        iconText="mdi-file-word-outline"
        tipo="agregar"
        @click="generarNuevaPlantilla"
      >
      </custom-button>
      <custom-button
        class="ml-2"
        label="Estado de Cuenta"
        iconText="fa-file-pdf"
        tipo="agregar"
        @click="generarEstadoCuenta"
      >
      </custom-button>
    </v-toolbar>
    <v-dialog
      v-model="mostrarGenerarNuevaPlantilla"
      scrollable
      persistent
      width="800"
    >
      <generar-nueva-plantilla
        modulo="contratos"
        :datos="getDatos"
        :idarchivo="titulo"
        ref="generarNuevaPlantilla"
        @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla"
      >
      </generar-nueva-plantilla>
    </v-dialog>

    <v-dialog
      v-model="mostrarGenerarEstadoCuenta"
      scrollable
      persistent
      width="600"
    >
      <generar-estado-cuenta
        ref="generarEstadoCuenta"
        @cerrarGenerarEstadoCuenta="cerrarGenerarEstadoCuenta"
      >
      </generar-estado-cuenta>
    </v-dialog>
  </div>
</template>

<script>
import ContratosSelector from '@/components/administracion/contratos/ContratosSelector.vue';
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import GenerarEstadoCuenta from '@/components/administracion/contratos/contrato/reportes/estadodecuenta/EstadoCuenta.vue';
import mixDatosContratos from '@/components/administracion/configuracion/plantillas/generador/mixDatosContratos';

export default {
  name: 'TituloToolBarContrato',
  components: {
    ContratosSelector, CustomButton, GenerarNuevaPlantilla, GenerarEstadoCuenta,
  },
  mixins: [mixDatosContratos],
  props: {
    titulo: {
      type: String,
      required: false,
      default: '# Contrato',
    },
    datos: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    fechas: {
      type: Array,
      required: true,
    },
    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      mostrarGenerarNuevaPlantilla: false,
      mostrarGenerarEstadoCuenta: false,
      mostrarBotonPlantillas: true,
    };
  },
  methods: {
    botonRegresar() {
      const { mostrarBtnRegresar, nombreRuta } = this;

      if (mostrarBtnRegresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },
    generarEstadoCuenta() {
      this.mostrarGenerarEstadoCuenta = !this.mostrarGenerarEstadoCuenta;
    },
    cerrarGenerarEstadoCuenta() {
      this.generarEstadoCuenta();
    },
  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      return this.formatoWordContrato(this.datos);
    },
  },
};
</script>

<style lang="scss">
</style>
